import { MapPin } from 'lucide-react';
import { Logo } from './Logo';
import { SmartLink } from './SmartLink';
import { footerColumns, socialLinks, contact } from '../data/site';
import { trackWhatsAppClick } from '../lib/analytics';

export function Footer() {
  return (
    <footer className="bg-ink text-white/70">
      <div className="container-content section-pad py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          {/* Brand */}
          <div className="max-w-xs">
            <Logo tone="light" />
            <p className="mt-5 font-sans text-sm font-light leading-relaxed text-white/55">
              Luxury photography &amp; curated experiences against the white-washed cliffs of
              Santorini.
            </p>
            <a
              href={contact.googleMaps}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 font-sans text-[0.6rem] font-medium uppercase tracking-label text-white/45 transition-colors hover:text-crimson-soft"
            >
              <MapPin className="h-3.5 w-3.5" strokeWidth={1.8} />
              {contact.location}
            </a>
          </div>

          {/* Link columns */}
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h2 className="font-sans text-[0.62rem] font-semibold uppercase tracking-label text-white/45">
                {col.title}
              </h2>
              <ul className="mt-5 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <SmartLink
                      href={link.href}
                      // The footer links are data-driven, so the WhatsApp one
                      // is spotted by its href rather than hard-coded here.
                      onClick={
                        link.href === contact.whatsapp
                          ? () => trackWhatsAppClick('footer')
                          : undefined
                      }
                      className="font-sans text-sm font-light text-white/75 transition-colors hover:text-crimson-soft"
                    >
                      {link.label}
                    </SmartLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Connect */}
          <div>
            <h2 className="font-sans text-[0.62rem] font-semibold uppercase tracking-label text-white/45">
              Connect
            </h2>
            <ul className="mt-5 flex items-center gap-3">
              {socialLinks.map(({ label, href, Icon }) => (
                <li key={label}>
                  <a
                    href={href}
                    target={href.startsWith('http') ? '_blank' : undefined}
                    rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    aria-label={label}
                    title={label}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/75 transition-colors hover:border-crimson-soft hover:text-crimson-soft"
                  >
                    <Icon className="h-[1.1rem] w-[1.1rem]" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 border-t border-white/10 pt-6">
          <p className="font-sans text-[0.7rem] text-white/40">
            &copy; 2026 Flying Muse. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
